import { format } from "util";
import { stringify } from "querystring";
import ApiService from "./ApiService";

const ENDPOINTS = {
  MEMBERSHIPS: "memberships/",
  MEMBERSHIP: "memberships/%s/",
  VARIATIONS: "memberships/%s/variations/",
  VARIATION: "memberships/%s/variations/%s/",
  SUBSCRIPTION: "contact-memberships/",
  CARDS: "contact-memberships/cards/",
  SUBSCRIPTIONS: "contact-memberships/",
  INVOICES: "contact-invoices/",
  CONTACT_CARDS: "contact-memberships/cards/",
  CREATE_CARD: "card/",
  DELETE_CARD: "card/%s/",
  ACTIVE_CARDS: "card/active/",
  CHANGE_MEMBERSHIP_CARD: "contact-memberships/%s/",
  AVAILABLE_CARDS: "contact-memberships/%s/cards/available/",
  LOYALTY_OFFER_MEMBERSHIPS: "loyalty-users/offer-memberships/",
  LOYALTY_USER_MEMBERSHIP: "loyalty-users/%s/",
  CANCEL_MEMBERSHIP: "contact-memberships/%s/",
};

class MembershipsService extends ApiService {
  createMembership = (payload) => {
    return this.apiClient.post(ENDPOINTS.MEMBERSHIPS, payload);
  };

  getMemberships = (payload) => {
    return this.apiClient.get(`${ENDPOINTS.MEMBERSHIPS}?${stringify(payload)}`);
  };

  getMembership = (membershipId) => {
    return this.apiClient.get(format(ENDPOINTS.MEMBERSHIP, membershipId));
  };

  disableMembership = (mebershipId) => {
    return this.apiClient.delete(format(ENDPOINTS.MEMBERSHIP, mebershipId));
  };

  patchMembership = (data) => {
    const { membershipId } = data;
    return this.apiClient.patch(
      format(ENDPOINTS.MEMBERSHIP, membershipId),
      data?.payload
    );
  };

  patchVariation = (data) => {
    const { membershipId, variationId } = data;
    return this.apiClient.patch(
      format(ENDPOINTS.VARIATION, membershipId, variationId),
      data?.payload
    );
  };

  createVariation = (payload) => {
    const { membershipId } = payload;
    return this.apiClient.post(
      format(ENDPOINTS.VARIATIONS, membershipId),
      payload?.data
    );
  };

  disableVariation = (payload) => {
    const { membershipId, variationId } = payload;
    return this.apiClient.delete(
      format(ENDPOINTS.VARIATION, membershipId, variationId)
    );
  };

  createSubscription = (payload) => {
    return this.apiClient.post(ENDPOINTS.SUBSCRIPTION, payload);
  };

  cancelContactMembership = (membershipId) => {
    return this.apiClient.delete(
      format(ENDPOINTS.CANCEL_MEMBERSHIP, membershipId)
    );
  };

  getLoyaltyOfferMemberships = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.LOYALTY_OFFER_MEMBERSHIPS}?${stringify(payload)}`
    );
  };

  getLoyaltyMembership = (membershipId) => {
    return this.apiClient.get(
      format(ENDPOINTS.LOYALTY_USER_MEMBERSHIP, membershipId)
    );
  };

  getContactCards = (payload) => {
    return this.apiClient.get(`${ENDPOINTS.CARDS}?${stringify(payload)}`);
  };

  getSubscriptions = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.SUBSCRIPTIONS}?${stringify(payload)}`
    );
  };

  getInvoices = (payload) => {
    return this.apiClient.get(`${ENDPOINTS.INVOICES}?${stringify(payload)}`);
  };

  cancelSubscription = (payload) => {
    return this.apiClient.delete(`${ENDPOINTS.SUBSCRIPTION}${payload?.id}/`);
  };

  listContactCards = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.CONTACT_CARDS}?${stringify(payload)}`
    );
  };

  listActiveContactCards = (payload) => {
    return this.apiClient.get(`${ENDPOINTS.ACTIVE_CARDS}?${stringify(payload)}`);
  };

  createCard = (payload) => {
    return this.apiClient.post(ENDPOINTS.CREATE_CARD, payload);
  };

  deleteCard = (cardId) => {
    return this.apiClient.delete(format(ENDPOINTS.DELETE_CARD, cardId));
  };

  changeMembershipCard = (payload) => {
    const { membershipId } = payload;
    return this.apiClient.put(
      format(ENDPOINTS.CHANGE_MEMBERSHIP_CARD, membershipId),
      payload
    );
  };

  listAvailableCards = (membershipId) => {
    return this.apiClient.get(format(ENDPOINTS.AVAILABLE_CARDS, membershipId));
  };
}

export default new MembershipsService();
